{
  "viewTransaction": "عرض الحركة المسجلة",
  "cashAmounts": "المبالغ النقدية حسب العملة",
  "addCurrency": "إضافة مبلغ بعملة أخرى",
  "removeCurrency": "إزالة العملة",
  "appName": "نظام صرف العملات",
  "brand": "المسافر",
  "dashboard": "ملخص الأرصدة النقدية",
  "exchange": "عملية صرف جديدة",
  "transactions": "الحركات",
  "cash": "الصناديق والخزائن",
  "rates": "أسعار الصرف",
  "reports": "التقارير",
  "configuration": "الإعدادات",
  "access": "المستخدمون والصلاحيات",
  "audit": "سجل التدقيق",
  "integration": "مزامنة حركات العملاء",
  "save": "حفظ",
  "working": "جاري التنفيذ...",
  "saved": "تم تسجيل العملية بنجاح.",
  "optional": "(اختياري)",
  "select": "اختر...",
  "invalidField": "تحقق من {{field}}.",
  "checkFields": "تحقق من الحقول المدخلة قبل المتابعة.",
  "uncertain": "نتيجة الطلب غير محسومة. احتفظ بهذا المرجع واستعلم عن الطلب الأصلي قبل إعادة المحاولة. لا تكرر حركة النقد الفعلية.",
  "recover": "استعلام عن الطلب الأصلي",
  "empty": "لا توجد سجلات مطابقة.",
  "emptyInitial": "لا توجد سجلات حتى الآن.",
  "resetFilters": "إزالة الفلاتر",
  "activeFilters": "الفلاتر الحالية",
  "clearFilter": "إزالة فلتر {{label}}",
  "branch": "الفرع",
  "chooseBranch": "اختر الفرع",
  "branchRequired": "اختر فرعا مصرحا لبدء العمل. يتحدد الصندوق والصلاحيات حسب هذا الفرع.",
  "account": "الصندوق أو الخزينة",
  "kind": "النوع",
  "available": "النقد المتاح",
  "incomingTransit": "وارد قيد النقل",
  "outgoingTransit": "صادر قيد النقل",
  "session": "يوم العمل",
  "custodyDescription": "النقد قيد النقل لا يدخل ضمن الرصيد المتاح لدى الجهة المستلمة. يدخل بعد تأكيد استلامه فعليا.",
  "noCommission": "عمولة الخدمة المنفصلة: 0. لا توجد رسوم صرف إضافية.",
  "refresh": "تحديث",
  "reason": "السبب",
  "physicalConfirmed": "أؤكد استلام المبلغ من العميل وتسليمه المبلغ المقابل فعليا.",
  "physicalHint": "أكد بعد التحقق الفعلي من العملات والمبالغ المحددة. كتابة السبب وحدها لا تثبت استلام النقد.",
  "pricingPath": "نوع السعر",
  "receivedCurrency": "العملة المستلمة من العميل",
  "receivedAmount": "المبلغ المستلم من العميل",
  "paidCurrency": "العملة المسلمة إلى العميل",
  "paidAmount": "المبلغ المدفوع للعميل",
  "phone": "رقم الهاتف الدولي",
  "phoneHint": "رقم الهاتف مع رمز الدولة مطلوب. بقية بيانات العميل اختيارية.",
  "fullName": "الاسم الكامل",
  "email": "البريد الإلكتروني",
  "address": "العنوان",
  "documentType": "نوع الوثيقة",
  "documentNumber": "رقم الوثيقة",
  "documentCountry": "رمز دولة الإصدار",
  "documentHint": "أضف نوع الوثيقة ورقمها ورمز دولة الإصدار من حرفين مثل JO.",
  "replacement": "إنشاء حركة بديلة مرتبطة",
  "replacementChain": "عملية بديلة للعملية {{reference}}. تبقى عملية العكس مسجلة حتى إذا تعذر تسجيل البديل.",
  "newExchange": "عملية صرف جديدة",
  "draftDescription": "أدخل بيانات العملية لمراجعة المبلغ المقابل قبل استلام النقد وتسليمه.",
  "offline": "الاتصال غير متاح. هذه المسودة ليست حركة مؤكدة أو إيصالا. الترحيل يتطلب اتصالا بنظام العملات والعملاء.",
  "lookupPhone": "رقم هاتف العميل",
  "lookup": "بحث عن العميل",
  "customerFound": "تم العثور على ملف العميل: {{name}}.",
  "customerNew": "لا يوجد ملف مطابق. سيتم إنشاء ملف للعميل عند تأكيد وتسجيل الصرف.",
  "calculate": "مراجعة عملية الصرف",
  "quoteReview": "مراجعة عملية الصرف قبل التسجيل",
  "quoteReviewHint": "تحقق من العملتين والمبالغ. يلزم إعادة الحساب عند تغيير الأسعار أو انتهاء صلاحية العرض.",
  "postExchange": "تأكيد وتسجيل الصرف",
  "posted": "تم تسجيل عملية الصرف",
  "postedDescription": "تم تسجيل العملية وتحديث رصيد الصندوق. يمكنك طباعة الإيصال دون إعادة تسجيل الصرف.",
  "priceVersion": "إصدار السعر",
  "receivedBuy": "سعر شراء العملة المستلمة",
  "paidSell": "سعر بيع العملة المدفوعة",
  "expiresAt": "انتهاء العرض",
  "roundingDifference": "فرق التقريب",
  "reference": "المرجع",
  "status": "الحالة",
  "createdAt": "وقت التسجيل",
  "originalId": "الحركة الأصلية",
  "reversalId": "عملية العكس المرتبطة",
  "replacementOfId": "بديل للحركة",
  "receipt": {
    "date": "التاريخ",
    "time": "الوقت",
    "received": "المبلغ المستلم",
    "paid": "المبلغ المدفوع",
    "rate": "سعر الصرف",
    "customerName": "اسم العميل",
    "customerPhone": "هاتف العميل",
    "reference": "المرجع",
    "thanks": "شكرا لزيارتكم"
  },
  "receiptCopy": "نسخة إيصال",
  "printingHint": "اطبع بعد نجاح الترحيل. إغلاق نافذة الطباعة أو فشلها لا يلغي الصرف.",
  "print": "طباعة الإيصال",
  "reprint": "تسجيل وطباعة نسخة",
  "printFailed": "تعذرت الطباعة. تبقى الحركة مرحلة ويمكن إعادة طباعتها.",
  "reprintReason": "طلب نسخة إضافية من الإيصال",
  "transaction": "تفاصيل الحركة",
  "reverse": "تسجيل عكس كامل للعملية",
  "alreadyReversed": "هذه العملية معكوسة بالفعل.",
  "cannotReverseReversal": "لا يمكن عكس عملية عكس.",
  "reversalPosted": "تم تسجيل عملية العكس",
  "denied": "هذه الخدمة خارج صلاحياتك.",
  "notFound": "الشاشة المطلوبة غير موجودة.",
  "search": "المرجع أو العميل",
  "currency": "العملة",
  "from": "من تاريخ",
  "to": "إلى تاريخ",
  "filters": "البحث والفلاتر",
  "applyFilters": "تطبيق الفلاتر",
  "page": "صفحة {{page}} من {{total}} · {{records}} سجل",
  "previous": "السابق",
  "next": "التالي",
  "issue": "تأكيد تسليم النقد",
  "receive": "تأكيد استلام النقد",
  "dispute": "تسجيل اعتراض على الاستلام",
  "cancelTransfer": "إلغاء طلب النقل غير المرسل",
  "transferNotDraft": "لم يعد هذا التحويل مسودة.",
  "transferNotAwaitingReceipt": "هذا التحويل ليس بانتظار الاستلام.",
  "transferSelfReceiveForbidden": "أنت من أرسل هذا التحويل؛ يجب أن يؤكد الاستلام موظف آخر.",
  "funding": "تسجيل تغذية الخزينة",
  "externalReference": "مرجع الاستلام الخارجي",
  "amount": "المبلغ",
  "newTransfer": "تحويل نقدي داخلي جديد",
  "fromAccount": "الصندوق أو الخزينة المرسلة",
  "toAccount": "الصندوق أو الخزينة المستلمة",
  "transfers": "التحويلات النقدية",
  "transfer": "تفاصيل التحويل النقدي",
  "newCount": "إدخال جرد نقد فعلي",
  "counts": "عمليات الجرد",
  "differences": "العجز / الزيادة",
  "count": "تفاصيل الجرد",
  "actual": "النقد الفعلي بحسب الجرد",
  "snapshot": "الرصيد المسجل عند الجرد",
  "approveCount": "اعتماد تسوية فرق الجرد",
  "rejectCount": "رفض الجرد",
  "countNotAwaitingApproval": "هذا الجرد ليس بانتظار الاعتماد.",
  "countSelfApproveForbidden": "أنت من أدخل هذا الجرد؛ يجب أن يعتمده مدير آخر.",
  "openSession": "فتح يوم العمل بالرصيد المرحل",
  "businessDate": "تاريخ يوم العمل",
  "sessions": "أيام العمل",
  "openingBalances": "الأرصدة الافتتاحية المرحلة",
  "closeSession": "إغلاق يوم العمل",
  "sessionAlreadyClosed": "يوم العمل هذا مغلق بالفعل.",
  "confirmedCount": "الجرد المؤكد الحالي",
  "nameAr": "الاسم بالعربية",
  "nameEn": "الاسم بالإنجليزية",
  "ratesHint": "الأسعار بالدينار الأردني لكل وحدة من العملة. تشتري المؤسسة من العميل وتبيع له. نسخة الأسعار واحدة، ويتطلب السعر الخاص صلاحية.",
  "ordinaryBuy": "سعر الشراء العادي",
  "ordinarySell": "سعر البيع العادي",
  "vipBuy": "سعر الشراء الخاص",
  "vipSell": "سعر البيع الخاص",
  "publishPrices": "اعتماد الأسعار",
  "priceHistory": "سجل الأسعار",
  "branches": "الفروع",
  "currencies": "العملات",
  "accounts": "الصناديق والخزائن",
  "name": "الاسم",
  "actions": "الإجراءات",
  "manageStatus": "إدارة الإتاحة",
  "newBranch": "إنشاء فرع",
  "code": "الرمز",
  "customerBranchRef": "مرجع الفرع المسجل في نظام العملاء",
  "newCurrency": "إضافة عملة",
  "currencyCode": "رمز العملة من ثلاثة أحرف",
  "cashScale": "الخانات العشرية للنقد",
  "newAccount": "إنشاء حساب نقدي",
  "parentAccount": "الخزينة التابعة لها",
  "cashier": "الصراف",
  "reassignAccount": "إعادة تعيين صندوق صراف مغلق وفارغ",
  "reassign": "إعادة التعيين",
  "permissions": "صلاحيات الخدمات",
  "description": "الوصف",
  "previewPermissions": "معاينة الصلاحيات المطلوبة",
  "effectivePermissions": "الصلاحيات الفعلية",
  "affectedUsers": "المستخدمون المتأثرون: {{count}}",
  "editGroup": "تعديل المجموعة",
  "newGroup": "إنشاء مجموعة",
  "deleteGroup": "إزالة المجموعة",
  "systemGroupProtected": "لا يمكن إزالة مجموعة المسؤول الافتراضية.",
  "users": "المستخدمون",
  "language": "اللغة",
  "arabic": "العربية",
  "english": "الإنجليزية",
  "newUser": "إنشاء مستخدم",
  "initialPassword": "كلمة المرور الأولية",
  "editUser": "تعديل المستخدم",
  "deleteUser": "تعطيل المستخدم",
  "groups": "مجموعات الصلاحيات",
  "members": "الأعضاء",
  "newMembership": "إضافة مستخدم إلى مجموعة",
  "user": "المستخدم",
  "group": "المجموعة",
  "scope": "النطاق",
  "scopeHint": "نطاق المؤسسة يتطلب عدم اختيار فروع. نطاق الفرع أو الصندوق الخاص يتطلب تحديد الفروع المصرح بها.",
  "memberships": "عضويات المجموعات",
  "removeMembership": "إزالة العضوية",
  "serviceCatalog": "دليل الخدمات والصلاحيات المطلوبة",
  "permission": "الخدمة",
  "dependencies": "الخدمات المطلوبة",
  "organizationOnly": "المؤسسة فقط",
  "scoped": "ضمن النطاق المعيّن",
  "reportsHint": "تعرض الإجماليات التدفقات النقدية المسجلة لكل عملة بشكل مستقل. لا تمثل أرباحا محاسبية.",
  "exchangeCount": "عمليات الصرف: {{count}}",
  "reversalCount": "عمليات العكس: {{count}}",
  "netCash": "صافي الحركة النقدية",
  "exportType": "تصدير {{type}} إلى Excel",
  "ledger": "دفتر النقد",
  "balances": "الأرصدة",
  "operation": "العملية",
  "beforeAmount": "الرصيد قبل",
  "afterAmount": "الرصيد بعد",
  "resource": "نوع السجل",
  "actor": "الموظف المنفذ",
  "requestId": "مرجع الطلب",
  "revision": "الإصدار",
  "attempts": "محاولات المزامنة",
  "lastError": "نتيجة آخر محاولة",
  "publicationFailed": "يحتاج نشر حركة العميل إلى إعادة محاولة أو مراجعة.",
  "retryPublication": "إعادة محاولة المزامنة",
  "publicationDelivered": "وصلت هذه الحركة إلى نظام العملاء بالفعل.",
  "values": {
    "prices_published": "نشر إصدار أسعار",
    "quote_created": "حساب عرض صرف",
    "exchange_posted": "ترحيل صرف",
    "exchange_reversed": "عكس صرف",
    "branch_created": "إنشاء فرع",
    "currency_created": "إضافة عملة",
    "account_created": "إنشاء حساب نقدي",
    "account_reassigned": "إعادة تعيين صندوق",
    "receipt_reprinted": "طلب نسخة إيصال",
    "report_exported": "تصدير تقرير",
    "outbox_retried": "إعادة نشر حركة عميل",
    "cash_funded": "استلام نقد خارجي",
    "transfer_created": "إعداد مسودة نقل",
    "transfer_issued": "إرسال نقد قيد النقل",
    "transfer_received": "استلام نقد فعلي",
    "transfer_cancelled": "إلغاء مسودة نقل",
    "transfer_disputed": "اعتراض على استلام",
    "count_submitted": "إدخال جرد فعلي",
    "count_rejected": "رفض جرد",
    "count_approved": "اعتماد تسوية جرد",
    "session_opened": "فتح يوم عمل",
    "session_closed": "إغلاق يوم عمل",
    "EXCHANGE_POST": "ترحيل صرف",
    "EXCHANGE_REVERSE": "عكس صرف",
    "EXTERNAL_RECEIPT": "استلام نقد خارجي",
    "User": "مستخدم",
    "Group": "مجموعة صلاحيات",
    "Membership": "عضوية بنطاق محدد",
    "Branch": "فرع",
    "Currency": "عملة",
    "CashAccount": "حساب نقدي",
    "PriceSet": "إصدار أسعار",
    "Quote": "عرض صرف",
    "Exchange": "صرف",
    "CashTransfer": "نقل نقدي",
    "PhysicalCount": "جرد فعلي",
    "FundSession": "يوم عمل",
    "ExternalReceipt": "استلام خارجي",
    "MovementOutbox": "نشر حركة عميل",
    "Report": "تقرير",
    "ACTIVE": "نشط",
    "DISABLED": "معطل",
    "SUSPENDED": "موقوف",
    "CENTRAL": "الخزينة المركزية",
    "BRANCH": "الفرع",
    "CASHIER": "صندوق صراف",
    "OPEN": "مفتوح",
    "CLOSED": "مغلق",
    "ORDINARY": "عادي",
    "VIP": "السعر الخاص",
    "NATIONAL_ID": "هوية وطنية",
    "PASSPORT": "جواز سفر",
    "EXCHANGE": "صرف",
    "REVERSAL": "عملية عكس",
    "POSTED": "مسجلة",
    "REVERSED": "تم عكسها",
    "DRAFT": "مسودة",
    "ISSUED": "قيد النقل",
    "RECEIVED": "مستلم",
    "DISPUTED": "قيد النقل مع اعتراض",
    "CANCELLED": "ملغى",
    "SUBMITTED": "بانتظار الاعتماد",
    "CONFIRMED": "مؤكد",
    "REJECTED": "مرفوض",
    "OWN_FUND": "صندوق الصراف الخاص",
    "ORGANIZATION": "المؤسسة",
    "PENDING": "بانتظار المزامنة",
    "PROCESSING": "جاري إرسال الحركة",
    "DELIVERED": "تم التسليم إلى نظام العملاء",
    "FAILED": "تعذرت المزامنة",
    "FUNDING": "تمويل خارجي",
    "TRANSFER_ISSUE": "إرسال نقل نقدي",
    "TRANSFER_RECEIVE": "استلام نقل نقدي",
    "COUNT_ADJUSTMENT": "تسوية جرد",
    "WEB": "الويب",
    "MOBILE": "الهاتف المحمول",
    "BRANCH_TREASURY": "خزينة الفرع",
    "auth_login": "تسجيل الدخول",
    "auth_refresh": "تجديد الجلسة",
    "auth_logout": "تسجيل الخروج",
    "auth_logout_all": "إنهاء جميع الجلسات",
    "auth_change_password": "تغيير كلمة المرور",
    "auth_context_selected": "اختيار الفرع",
    "user_created": "إنشاء مستخدم",
    "user_updated": "تعديل مستخدم",
    "user_deleted": "تعطيل مستخدم",
    "group_created": "إنشاء مجموعة صلاحيات",
    "group_updated": "تعديل مجموعة صلاحيات",
    "group_deleted": "حذف مجموعة صلاحيات",
    "membership_created": "إضافة عضوية",
    "membership_deleted": "إزالة عضوية",
    "entity_status_changed": "تغيير حالة السجل",
    "Session": "جلسة دخول"
  },
  "permissionLabels": {
    "USER_READ": "عرض المستخدمين",
    "USER_MANAGE": "إدارة المستخدمين",
    "GROUP_READ": "عرض المجموعات",
    "GROUP_MANAGE": "إدارة المجموعات",
    "MEMBERSHIP_MANAGE": "إدارة العضويات ونطاقاتها",
    "CONFIG_READ": "عرض الإعدادات",
    "CONFIG_MANAGE": "إدارة الإعدادات",
    "RATE_READ": "عرض الأسعار",
    "RATE_MANAGE": "نشر الأسعار",
    "CUSTOMER_RESOLVE": "البحث عن العميل في نظام العملاء",
    "QUOTE_CREATE": "حساب الصرف",
    "EXCHANGE_POST": "ترحيل الصرف",
    "VIP_USE": "استخدام الأسعار الخاصة",
    "EXCHANGE_READ": "عرض الصرف",
    "EXCHANGE_REVERSE": "عكس الصرف",
    "RECEIPT_READ": "عرض الإيصالات وإعادة طباعتها",
    "CASH_READ": "عرض العهد النقدية",
    "FUNDING_POST": "تسجيل تمويل خارجي",
    "TRANSFER_CREATE": "إعداد نقل النقد",
    "TRANSFER_ISSUE": "إرسال نقل النقد",
    "TRANSFER_RECEIVE": "استلام نقل النقد",
    "TRANSFER_REVIEW": "مراجعة اعتراضات النقل",
    "COUNT_ENTER": "إدخال الجرد",
    "COUNT_APPROVE": "اعتماد تسويات الجرد",
    "SESSION_OPEN": "فتح يوم العمل",
    "SESSION_CLOSE": "إغلاق يوم العمل",
    "REPORT_READ": "عرض التقارير",
    "REPORT_EXPORT": "تصدير التقارير",
    "AUDIT_READ": "عرض التدقيق",
    "INTEGRATION_READ": "عرض حالة مزامنة حركات العملاء",
    "INTEGRATION_RETRY": "إعادة محاولة مزامنة حركات العملاء"
  },
  "pendingOperations": "طلبات غير محسومة",
  "recoveredReference": "تم استرجاع النتيجة الأصلية: {{reference}}",
  "changePassword": "تغيير كلمة المرور",
  "passwordChangeHint": "تغيير كلمة المرور ينهي جميع الجلسات النشطة. سجل الدخول مجددا بكلمة المرور الجديدة.",
  "currentPassword": "كلمة المرور الحالية",
  "newPassword": "كلمة المرور الجديدة",
  "confirmPassword": "تأكيد كلمة المرور الجديدة",
  "activeSessions": "الجلسات النشطة",
  "logoutAll": "تسجيل خروج جميع الجلسات",
  "logoutAllHint": "إنهاء جميع الجلسات النشطة لحسابك على جميع الأجهزة.",
  "customerId": "معرف العميل المركزي",
  "channel": "قناة التنفيذ",
  "verifiedAt": "وقت التحقق من العميل",
  "cancelEntry": "إغلاق النموذج",
  "cashierFund": "صندوق الصراف",
  "exchangeContext": "الصندوق والأسعار",
  "customerGives": "نستلم من العميل",
  "customerReceives": "نسلم إلى العميل",
  "customer": "بيانات العميل",
  "optionalCustomerDetails": "إضافة بيانات العميل الاختيارية",
  "phoneInvalid": "أدخل رقم هاتف صالحا مع رمز الدولة، مثل ‎+962790000000‎.",
  "documentInvalid": "أكمل نوع الوثيقة ورقمها ودولة إصدارها من حرفين، أو اتركها فارغة بالكامل.",
  "emailInvalid": "أدخل بريدا إلكترونيا صالحا.",
  "decimalInvalid": "أدخل قيمة رقمية صحيحة باستخدام الأرقام 0–9 والنقطة للفاصل العشري.",
  "physicalRequired": "يجب تأكيد حركة النقد الفعلية قبل تسجيل العملية.",
  "calculationDetails": "تفاصيل احتساب المبلغ",
  "recordDetails": "تفاصيل إضافية ومراجع السجل",
  "unnamedCustomer": "اسم العميل غير مسجل",
  "unavailableName": "الاسم غير متاح ضمن صلاحياتك",
  "physicalReversal": "أؤكد استرداد المبلغ المدفوع للعميل وإعادة المبلغ المستلم منه فعليا.",
  "physicalIssue": "أؤكد تسليم المبالغ المحددة للإرسال فعليا.",
  "physicalReceive": "أؤكد استلام المبالغ المحددة فعليا والتحقق من عملاتها وقيمها.",
  "physicalIssueHint": "يبقى النقد قيد النقل حتى يؤكد موظف آخر استلامه لدى الجهة المستلمة.",
  "physicalReceiveHint": "تحقق من النقد الفعلي قبل التأكيد؛ سيتم إضافته إلى الرصيد المتاح.",
  "createTransferDraft": "إنشاء مسودة تحويل",
  "submitCount": "تسجيل نتيجة الجرد",
  "chooseAccountHint": "اختر الصندوق أو الخزينة لعرض الأرصدة والإجراءات المتاحة.",
  "transferFlowHint": "أنشئ مسودة التحويل، ثم أكد تسليم النقد للإرسال. يؤكد موظف آخر الاستلام الفعلي لدى الجهة المستلمة.",
  "countFlowHint": "أدخل المبالغ المعدودة فعليا لكل عملة. فرق الجرد = النقد الفعلي − الرصيد المسجل؛ السالب عجز والموجب زيادة.",
  "sessionFlowHint": "يفتح يوم العمل بالرصيد المرحل من اليوم السابق. يتطلب الإغلاق جردا مؤكدا وحديثا؛ ويبقى النقد في عهدة الصراف.",
  "dashboardHint": "ابدأ عملية صرف أو راجع أرصدة صناديق الفرع وحالة أيام العمل.",
  "selectedBranchBalances": "الأرصدة التي يمكنك عرضها ضمن الفرع المحدد. تظهر كل عملة بصورة مستقلة.",
  "allPermittedBranches": "جميع الفروع ضمن صلاحياتك",
  "allPermittedAccounts": "جميع الصناديق والخزائن ضمن صلاحياتك",
  "allDates": "جميع التواريخ",
  "directorySearch": "البحث بالاسم",
  "generatedAt": "وقت إعداد التقرير",
  "updatePrices": "تحديث أسعار الصرف",
  "baseCurrencyHint": "الدينار الأردني هو العملة المرجعية وسعره ثابت عند 1. أدخل سعر كل عملة بالدينار الأردني.",
  "permissionCount": "عدد الصلاحيات: {{count}}",
  "searchPermissions": "البحث عن صلاحية",
  "profile": "الحساب والأمان",
  "reversalHint": "يعكس هذا الإجراء العملية كاملة بالمبالغ والعملات الأصلية، دون استخدام الأسعار الحالية. تبقى العملية الأصلية وسجل العكس محفوظين.",
  "countOption": "جرد {{date}} — نسخة الرصيد {{revision}}",
  "unknownStatus": "حالة غير معروفة",
  "requiredField": "أكمل حقل {{field}} للمتابعة.",
  "offlineCash": "الاتصال غير متاح. احتفظ بالمسودة؛ لا يمكن تأكيد حركة النقد قبل عودة الاتصال.",
  "employeeReference": "مرجع الموظف",
  "shared": {
    "branchSwitchHint": "يبقى العمل غير المكتمل مرتبطا بفرعه الأصلي. راجع العمليات المعلقة قبل التبديل، وأعد مراجعة عروض الصرف المحفوظة عند العودة.",
    "confirmSwitch": "تبديل الفرع",
    "account": "الحساب الموحد",
    "accountHint": "تدير منصة الدخول الموحد بيانات الدخول والاسم واللغة وكلمة المرور. تبقى صلاحيات العملات والحالة المحلية هنا.",
    "manageAccount": "فتح منصة الدخول الموحد",
    "enroll": "إضافة موظف من الدخول الموحد",
    "enrollHint": "ابحث عن الموظف أو أنشئ هويته الموحدة، ثم عيّن المجموعة والفرع محليا. يبقى تعيين الصندوق مستقلا.",
    "provisionRecovery": "إذا انقطعت الإضافة، ابحث باسم المستخدم نفسه وأكمل الربط. إنشاء الهوية وحده لا يمنح صلاحية الدخول إلى نظام العملات.",
    "findEmployee": "البحث عن موظف",
    "createEmployee": "إنشاء هوية موحدة",
    "linkIdentity": "ربط الهوية الموحدة",
    "username": "اسم المستخدم",
    "notFound": "لا يوجد موظف باسم المستخدم هذا.",
    "retainHistory": "سيتم ربط الحساب الموحد بالموظف {{name}} مع الاحتفاظ بسجله المالي وتعييناته المحلية. سينتهي الدخول بكلمة المرور المحلية.",
    "confirmEnrollment": "تأكيد إضافة الموظف",
    "branchMappings": "ربط الفروع بالدليل الموحد",
    "branchMappingsHint": "اربط كل فرع في نظام العملات بالفرع المطابق في الدليل الموحد. يحتفظ النظام بالسجل المالي ومرجع فرع العملاء الحاليين.",
    "mappingStatus": "حالة الربط",
    "mapped": "مرتبط",
    "unmapped": "غير مرتبط",
    "mapBranch": "ربط الفرع",
    "centralBranch": "الفرع الموحد",
    "previousPage": "الفروع السابقة",
    "nextPage": "المزيد من الفروع",
    "accessPending": "تم إنشاء الهوية الموحدة، وما زالت الإضافة إلى نظام العملات معلقة. راجع الموظف أدناه وأكمل الربط.",
    "membershipRequired": "تمت إضافة الموظف. عيّن المجموعة والفرع من قسم العضويات قبل منحه صلاحية العمل."
  },
  "screenPending": "سيتم بناء هذه الشاشة في خطوة لاحقة من إعادة البناء.",
  "treasury": "الخزينة",
  "usersScreen": {
    "title": "المستخدمين",
    "add": "إضافة مستخدم",
    "columns": {
      "name": "الاسم",
      "username": "اسم المستخدم",
      "email": "البريد الإلكتروني",
      "group": "المجموعة",
      "branches": "الفروع",
      "cashier": "أمين صندوق",
      "status": "الحالة",
      "lastLogin": "آخر تسجيل دخول"
    },
    "cashierBadge": "أمين صندوق",
    "active": "مفعل",
    "inactive": "معطل",
    "neverLoggedIn": "لم يسجل الدخول بعد",
    "edit": "تعديل",
    "delete": "حذف",
    "changeStatus": "تغيير الحالة",
    "cancel": "إلغاء",
    "save": "حفظ",
    "saving": "جاري الحفظ...",
    "requiredFieldsNote": "الحقول المطلوبة مشار إليها بعلامة *.",
    "noResults": "لا توجد نتائج مطابقة.",
    "created": "تم إضافة المستخدم بنجاح.",
    "updated": "تم تحديث بيانات المستخدم بنجاح.",
    "deleted": "تم حذف المستخدم بنجاح.",
    "statusChanged": "تم تحديث حالة المستخدم.",
    "passwordReset": "تم إعادة تعيين كلمة المرور.",
    "statusConfirmTitle": "تأكيد تغيير الحالة",
    "deleteConfirmTitle": "تأكيد حذف المستخدم",
    "deleteConfirmDescription": "سيتم حذف وصول {{name}} إلى هذا النظام فقط. الحساب المشترك في الدخول الموحد يبقى كما هو.",
    "resetPasswordConfirmTitle": "تأكيد إعادة تعيين كلمة المرور",
    "resetPasswordConfirmDescription": "سيتم إرسال كلمة مرور جديدة لـ {{name}}.",
    "rowActionsTrigger": "إجراءات المستخدم {{name}}",
    "drawer": {
      "createTitle": "إضافة مستخدم",
      "editTitle": "تعديل المستخدم",
      "createDescription": "ابحث عن موظف موجود أو أضف مستخدما جديدا.",
      "editDescription": "عدل بيانات المستخدم وصلاحياته.",
      "usernameSearch": "البحث عن موظف",
      "usernameSearchPlaceholder": "اسم المستخدم في الدخول الموحد",
      "search": "بحث",
      "foundEmployee": "تم العثور على موظف",
      "useNewEmployee": "استخدام موظف جديد بدلا من ذلك",
      "fields": {
        "username": "اسم المستخدم",
        "nameAr": "الاسم بالعربية",
        "nameEn": "الاسم بالإنجليزية",
        "email": "البريد الإلكتروني",
        "phone": "الهاتف",
        "group": "المجموعة",
        "branches": "الفروع"
      }
    },
    "discardTitle": "تجاهل التغييرات؟",
    "discardDescription": "لديك تغييرات غير محفوظة. هل تريد تجاهلها؟",
    "discardConfirm": "تجاهل",
    "discardCancel": "متابعة التعديل",
    "resetPassword": {
      "title": "إعادة تعيين كلمة المرور",
      "emailedDescription": "تم إرسال كلمة مرور جديدة إلى بريد المستخدم الإلكتروني.",
      "linkDescription": "استخدم الرابط التالي لتعيين كلمة مرور جديدة.",
      "copy": "نسخ",
      "copied": "تم النسخ",
      "close": "إغلاق"
    },
    "setupLink": {
      "title": "رابط إكمال التسجيل",
      "emailedDescription": "تم إرسال رابط إكمال التسجيل بالبريد",
      "linkDescription": "استخدم الرابط التالي لإكمال تسجيل المستخدم.",
      "copy": "نسخ",
      "copied": "تم النسخ",
      "close": "إغلاق"
    },
    "search": "الاسم أو المستخدم"
  },
  "groupsScreen": {
    "title": "المجموعات",
    "add": "إضافة مجموعة",
    "columns": {
      "name": "الاسم",
      "description": "الوصف",
      "users": "المستخدمين",
      "services": "الخدمات",
      "status": "الحالة"
    },
    "active": "مفعلة",
    "inactive": "معطلة",
    "edit": "تعديل",
    "delete": "حذف",
    "changeStatus": "تغيير الحالة",
    "assignServices": "تعيين الخدمات",
    "cancel": "إلغاء",
    "save": "حفظ",
    "saving": "جاري الحفظ...",
    "requiredFieldsNote": "الحقول المطلوبة مشار إليها بعلامة *.",
    "noResults": "لا توجد نتائج مطابقة.",
    "created": "تم إضافة المجموعة بنجاح.",
    "updated": "تم تحديث بيانات المجموعة بنجاح.",
    "deleted": "تم حذف المجموعة بنجاح.",
    "statusChanged": "تم تحديث حالة المجموعة.",
    "statusConfirmTitle": "تأكيد تغيير الحالة",
    "deleteConfirmTitle": "تأكيد حذف المجموعة",
    "deleteConfirmDescription": "سيتم حذف مجموعة {{name}} نهائيا.",
    "rowActionsTrigger": "إجراءات مجموعة {{name}}",
    "drawer": {
      "createTitle": "إضافة مجموعة",
      "editTitle": "تعديل المجموعة",
      "createDescription": "أضف مجموعة جديدة، ثم عيّن خدماتها من قائمة المجموعات.",
      "editDescription": "عدل اسم المجموعة ووصفها.",
      "fields": {
        "nameAr": "الاسم بالعربية",
        "nameEn": "الاسم بالإنجليزية",
        "descriptionAr": "الوصف بالعربية",
        "descriptionEn": "الوصف بالإنجليزية"
      }
    },
    "discardTitle": "تجاهل التغييرات؟",
    "discardDescription": "لديك تغييرات غير محفوظة. هل تريد تجاهلها؟",
    "discardConfirm": "تجاهل",
    "discardCancel": "متابعة التعديل",
    "search": "اسم المجموعة"
  },
  "exchangeForm": {
    "cancel": "إلغاء"
  },
  "boxesScreen": {
    "title": "الصناديق",
    "tabBoxes": "الصناديق",
    "tabMovements": "حركات الصناديق",
    "branch": "الفرع",
    "cashierName": "أمين الصندوق",
    "boxBalance": "رصيد الصندوق",
    "status": "الحالة",
    "viewBalance": "عرض الرصيد",
    "balanceDialogTitle": "رصيد الصندوق",
    "number": "رقم الحركة",
    "date": "التاريخ",
    "customerName": "اسم العميل",
    "customerPhone": "هاتف العميل",
    "receivedCurrency": "العملة المستلمة",
    "receivedAmount": "المبلغ المستلم",
    "paidCurrency": "العملة المدفوعة",
    "paidAmount": "المبلغ المدفوع",
    "profit": "ربح الحركة",
    "reversalNote": "عكس للعملية {{reference}}: {{reason}}",
    "notes": "ملاحظات",
    "statusPosted": "منفذة",
    "statusReversed": "معكوسة",
    "syncPending": "بانتظار المزامنة",
    "fromDate": "من تاريخ",
    "toDate": "إلى تاريخ",
    "filterBranch": "الفرع",
    "filterCashier": "أمين الصندوق",
    "filterCurrencyIn": "العملة المستلمة",
    "filterCurrencyOut": "العملة المدفوعة",
    "filterStatus": "الحالة",
    "allBranches": "جميع الفروع",
    "allCashiers": "جميع أمناء الصناديق",
    "allCurrencies": "جميع العملات",
    "allStatuses": "جميع الحالات",
    "export": "تصدير إلى Excel",
    "view": "عرض",
    "reprint": "إعادة طباعة",
    "reverse": "عكس العملية",
    "reverseTitle": "عكس عملية الصرف",
    "reverseReason": "سبب العكس",
    "reverseWarning": "سيعيد الصندوق العملة المستلمة إلى العميل ويسترد العملة المدفوعة له. لا يمكن التراجع عن هذا الإجراء.",
    "reverseOriginal": "استلم الصندوق {{received}} ودفع {{paid}}. سيتم عكس ذلك بالكامل.",
    "reverseConfirm": "تأكيد العكس",
    "reversePosted": "تم تسجيل عملية العكس.",
    "alreadyReversed": "هذه العملية معكوسة بالفعل.",
    "detailsTitle": "تفاصيل الحركة",
    "close": "إغلاق",
    "activeBox": "نشط",
    "inactiveBox": "غير نشط",
    "search": "الاسم أو الهاتف",
    "photo": "صورة العميل",
    "photoFailed": "تعذر تحميل الصورة.",
    "signature": "توقيع العميل",
    "signatureFailed": "تعذر تحميل التوقيع.",
    "customerNotPresent": "العميل غير موجود",
    "signedAt": "التاريخ والوقت",
    "signedName": "اسم العميل",
    "reversedBy": "تم العكس بواسطة",
    "reversedAt": "تاريخ العكس",
    "boxName": "اسم الصندوق",
    "employees": "الموظفون",
    "box": "الصندوق",
    "edit": "تعديل",
    "addBox": "إضافة صندوق",
    "filterBox": "الصندوق",
    "allBoxes": "جميع الصناديق",
    "drawer": {
      "createTitle": "إضافة صندوق",
      "editTitle": "تعديل صندوق",
      "createDescription": "أدخل اسم الصندوق واختر فرعه والموظفين الذين يعملون عليه.",
      "editDescription": "عدل اسم الصندوق والموظفين. لا يتغير رصيد الصندوق.",
      "name": "اسم الصندوق",
      "chooseBranch": "اختر الفرع",
      "branchFixed": "لا يمكن تغيير فرع الصندوق بعد إضافته.",
      "employees": "الموظفون",
      "chooseEmployees": "اختر الموظفين",
      "chooseBranchFirst": "اختر الفرع أولا",
      "chooseEmployee": "اختر موظفا واحدا على الأقل",
      "employeesHint": "تظهر فقط حسابات الموظفين الفعالة في فرع الصندوق.",
      "noEligibleEmployees": "لا يوجد موظفون متاحون في هذا الفرع.",
      "employeesFailed": "تعذر تحميل الموظفين.",
      "nameTaken": "اسم الصندوق مستخدم في هذا الفرع",
      "created": "تمت إضافة الصندوق.",
      "updated": "تم تعديل الصندوق."
    },
    "changeStatus": "تغيير الحالة",
    "statusConfirmTitle": "تأكيد تغيير الحالة",
    "statusConfirmDeactivate": "سيتم تعطيل {{name}}. لن يظهر في تطبيق الصرف ولا يمكن تغذيته، ويبقى موظفوه مرتبطين به.",
    "statusConfirmActivate": "سيتم تفعيل {{name}}. سيظهر لموظفيه في تطبيق الصرف.",
    "statusChanged": "تم تحديث حالة الصندوق.",
    "confirm": "تأكيد",
    "cancel": "إلغاء",
    "saving": "جاري الحفظ...",
    "customersRefused": "رفض نظام العملاء هذا الرقم، عدّل رقم الهاتف"
  },
  "currenciesScreen": {
    "title": "العملات",
    "add": "إضافة عملة",
    "columns": {
      "name": "اسم العملة",
      "code": "رمز العملة",
      "buy": "سعر الشراء",
      "sell": "سعر البيع",
      "vipBuy": "سعر الشراء VIP",
      "vipSell": "سعر البيع VIP",
      "status": "الحالة",
      "updatedAt": "آخر تعديل"
    },
    "active": "مفعلة",
    "inactive": "معطلة",
    "locked": "عملة مرجعية",
    "edit": "تعديل",
    "changeStatus": "تغيير الحالة",
    "createTitle": "إضافة عملة",
    "editTitle": "تعديل العملة",
    "createDescription": "أضف عملة جديدة وأسعارها.",
    "editDescription": "عدل بيانات العملة وأسعارها.",
    "fields": {
      "nameAr": "الاسم بالعربية",
      "nameEn": "الاسم بالإنجليزية",
      "code": "رمز العملة",
      "codeHint": "رمز دولي من ثلاثة أحرف، مثل USD.",
      "buy": "سعر الشراء",
      "sell": "سعر البيع",
      "vipEnabled": "تفعيل سعر VIP",
      "vipBuy": "سعر الشراء VIP",
      "vipSell": "سعر البيع VIP"
    },
    "sellAtLeastBuy": "سعر البيع يجب أن يكون أكبر من أو يساوي سعر الشراء.",
    "vipSellAtLeastBuy": "سعر بيع VIP يجب أن يكون أكبر أو يساوي سعر شراء VIP.",
    "codeInvalid": "أدخل رمزا من ثلاثة أحرف إنجليزية، مثل USD.",
    "created": "تم إضافة العملة بنجاح.",
    "updated": "تم تحديث بيانات العملة بنجاح.",
    "statusChanged": "تم تحديث حالة العملة.",
    "statusConfirmTitle": "تأكيد تغيير الحالة",
    "statusConfirmActivate": "سيتم تفعيل عملة {{name}}. يمكن استخدامها في عمليات الصرف بعد التفعيل.",
    "statusConfirmDeactivate": "سيتم تعطيل عملة {{name}}. لن تكون متاحة في عمليات الصرف الجديدة.",
    "confirm": "تأكيد",
    "cancel": "إلغاء",
    "save": "حفظ",
    "saving": "جاري الحفظ...",
    "noActions": "عملة مرجعية بلا إجراءات",
    "rowActionsTrigger": "إجراءات عملة {{code}}",
    "discardTitle": "تجاهل التغييرات؟",
    "discardDescription": "لديك تغييرات غير محفوظة. هل تريد تجاهلها؟",
    "discardConfirm": "تجاهل",
    "discardCancel": "متابعة التعديل",
    "search": "الرمز أو الاسم",
    "noResults": "لا توجد عملات مطابقة لبحثك."
  },
  "treasuryScreen": {
    "title": "الخزينة",
    "centralFeedButton": "تغذية الخزينة المركزية",
    "feedButton": "تغذية صندوق",
    "returnButton": "توريد",
    "countButton": "جرد صندوق",
    "tabVaults": "الخزائن",
    "tabFeeds": "تغذية الصناديق",
    "tabCounts": "جرد الصناديق",
    "central": "الخزينة المركزية",
    "branchTreasury": "خزينة {{branch}}",
    "viewBalance": "عرض الرصيد",
    "vaultsColumns": {
      "name": "الجهة",
      "balance": "الرصيد"
    },
    "feedsColumns": {
      "number": "الرقم",
      "date": "التاريخ",
      "type": "نوع الحركة",
      "from": "من",
      "to": "إلى",
      "amounts": "المبالغ",
      "actor": "القائم بالعملية",
      "notes": "ملاحظات"
    },
    "moveTypeOpening": "رصيد افتتاحي",
    "moveTypeFeed": "تغذية",
    "moveTypeReturn": "توريد",
    "countsColumns": {
      "number": "الرقم",
      "date": "التاريخ",
      "account": "الصندوق أو الخزينة",
      "actor": "القائم بالجرد",
      "difference": "الفرق",
      "notes": "ملاحظات"
    },
    "surplus": "فائض",
    "shortage": "نقص",
    "balanced": "متوازن",
    "centralFeedTitle": "تغذية الخزينة المركزية",
    "centralFeedDescription": "أضف نقدا واردا من خارج النظام إلى الخزينة المركزية.",
    "moveType": "نوع الحركة",
    "moveTypeOpeningOption": "رصيد افتتاحي",
    "moveTypeFeedOption": "تغذية",
    "feedTitle": "تغذية صندوق",
    "feedDescription": "انقل نقدا من الخزينة المركزية إلى فرع، أو من فرع إلى صندوق.",
    "returnTitle": "توريد",
    "returnDescription": "أعد نقدا من صندوق إلى فرعه، أو من فرع إلى الخزينة المركزية.",
    "from": "من",
    "to": "إلى",
    "chooseFrom": "اختر الجهة المرسلة",
    "chooseTo": "اختر الجهة المستلمة",
    "amountsTitle": "المبالغ",
    "availableBalance": "المتاح: {{amount}}",
    "notes": "ملاحظات",
    "notesOptional": "ملاحظات (اختياري)",
    "confirmTitle": "تأكيد الحركة",
    "confirmBody": "سيتم نقل {{amounts}} من {{from}} إلى {{to}}.",
    "centralFeedConfirmBody": "سيتم إضافة {{amounts}} إلى الخزينة المركزية.",
    "confirm": "تأكيد",
    "cancel": "إلغاء",
    "save": "حفظ",
    "saving": "جاري الحفظ...",
    "centralFeedPosted": "تم تسجيل تغذية الخزينة المركزية.",
    "feedPosted": "تم تسجيل التغذية.",
    "returnPosted": "تم تسجيل التوريد.",
    "amountExceedsBalance": "المبلغ أكبر من الرصيد المتاح.",
    "atLeastOneLine": "أدخل مبلغا لعملة واحدة على الأقل.",
    "amountTooManyDecimals": "يسمح بخمس منازل عشرية كحد أقصى.",
    "countTitle": "جرد صندوق",
    "countDescription": "اختر الصندوق أو الخزينة، ثم أدخل النقد الفعلي لكل عملة.",
    "countHolder": "الصندوق أو الخزينة",
    "chooseHolder": "اختر الصندوق أو الخزينة",
    "systemBalance": "الرصيد في النظام",
    "actualCash": "النقد الفعلي",
    "difference": "الفرق",
    "notesRequiredOnDifference": "أدخل ملاحظات عند وجود فرق في الجرد.",
    "confirmCount": "تأكيد الجرد",
    "countPosted": "تم تسجيل الجرد.",
    "noHolderBalances": "لا توجد أرصدة لهذه الجهة.",
    "discardTitle": "تجاهل التغييرات؟",
    "discardDescription": "لديك تغييرات غير محفوظة. هل تريد تجاهلها؟",
    "discardConfirm": "تجاهل",
    "discardCancel": "متابعة التعديل"
  },
  "servicesScreen": {
    "title": "تعيين الخدمات",
    "description": "حدد الخدمات المتاحة لهذه المجموعة.",
    "save": "حفظ الصلاحيات",
    "saving": "جاري الحفظ...",
    "saved": "تم حفظ الصلاحيات بنجاح.",
    "search": "بحث عن خدمة",
    "selectAll": "تحديد الكل",
    "deselectAll": "إلغاء تحديد الكل",
    "unsavedChanges": "توجد تغييرات غير محفوظة.",
    "discardTitle": "تجاهل التغييرات؟",
    "discardDescription": "لديك تغييرات غير محفوظة في الصلاحيات. هل تريد تجاهلها؟",
    "discard": "تجاهل",
    "keepEditing": "متابعة التعديل"
  },
  "reportsScreen": {
    "title": "تقارير وإحصائيات",
    "fromDate": "من تاريخ",
    "toDate": "إلى تاريخ",
    "filterBranch": "الفرع",
    "allBranches": "جميع الفروع",
    "exportToExcel": "تصدير إلى Excel",
    "profitOverview": {
      "title": "نظرة عامة على الأرباح",
      "week": "أسبوعي",
      "month": "شهري",
      "year": "سنوي"
    },
    "currencyBalances": {
      "title": "أرصدة العملات"
    },
    "boxPerformance": {
      "title": "أداء الصناديق",
      "box": "الصندوق",
      "cashier": "أمين الصندوق",
      "count": "عدد الحركات",
      "profit": "الربح (دينار)"
    },
    "cashierPerformance": {
      "title": "أداء أمناء الصناديق",
      "cashier": "أمين الصندوق",
      "count": "عدد الحركات",
      "profit": "الربح (دينار)"
    },
    "currencyPerformance": {
      "title": "أداء العملات",
      "code": "العملة",
      "count": "عدد الحركات",
      "received": "المستلم",
      "paid": "المدفوع"
    },
    "cashMoves": {
      "title": "تغذية الصناديق",
      "number": "الرقم",
      "date": "التاريخ",
      "type": "النوع",
      "from": "من",
      "to": "إلى",
      "amounts": "المبالغ",
      "actor": "القائم بالعملية"
    },
    "boxBalances": {
      "title": "أرصدة الصناديق",
      "branch": "الفرع",
      "box": "الصندوق",
      "employees": "الموظفون",
      "balances": "الأرصدة"
    },
    "vaultBalances": {
      "title": "أرصدة الخزائن",
      "kind": "النوع",
      "central": "الخزينة المركزية",
      "branch": "خزينة فرع",
      "branchName": "الفرع",
      "balances": "الأرصدة"
    },
    "differences": {
      "title": "الفروقات",
      "count": "رقم الجرد",
      "date": "التاريخ",
      "branch": "الفرع",
      "actor": "القائم بالجرد",
      "currency": "العملة",
      "difference": "الفرق",
      "kind": "النوع",
      "surplus": "فائض",
      "shortage": "نقص"
    }
  },
  "exchangeSettings": {
    "title": "إعدادات الصرف",
    "phoneVerification": "تأكيد رقم الهاتف برمز واتساب",
    "phoneVerificationHelp": "يرسل رمز عبر واتساب عند إضافة عميل أو تغيير رقم الهاتف. ولا يتم الحفظ إلا بعد إدخال الرمز.",
    "saved": "تم تحديث إعدادات الصرف بنجاح"
  }
}
